// Inline PDF viewer using a short-lived read SAS URL minted by
// /:id/pdf-url. The browser's built-in PDF viewer renders the iframe; if
// a user has disabled it, the fallback link still lets them open the
// PDF in a new tab. The SAS expires server-side after 15 minutes — when
// it does, the user just refreshes the tab to mint a new one.
import { useEffect, useState } from "react";
import { api } from "../../../lib/api";

interface Props {
  projectId: number;
}

export function PdfPreview({ projectId }: Props) {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setUrl(null);
    setError(null);
    void (async () => {
      try {
        const r = await api<{ url: string; expiresAt: string }>(
          `/api/tools/pipe-takeoff/projects/${projectId}/pdf-url`,
        );
        setUrl(r.url);
      } catch (e) {
        setError(e instanceof Error ? e.message : String(e));
      }
    })();
  }, [projectId]);

  if (error) {
    return (
      <div className="bsp-card" style={{ borderColor: "var(--bsp-red)" }}>
        <p style={{ color: "var(--bsp-red-fg)", margin: 0 }}>{error}</p>
      </div>
    );
  }

  if (!url) return <p>Loading PDF…</p>;

  return (
    <div className="bsp-card" style={{ padding: 0, overflow: "hidden" }}>
      <iframe
        title="Source PDF"
        src={url}
        style={{ width: "100%", height: "calc(100vh - 220px)", border: 0, display: "block" }}
      />
      <div style={{ padding: "8px 12px", borderTop: "1px solid var(--bsp-border)", fontSize: 12 }}>
        <a href={url} target="_blank" rel="noopener noreferrer">
          Open in new tab
        </a>
      </div>
    </div>
  );
}
